import * as yup from "yup"

export const regex = {
  singleName: /^[a-zA-Zא-ת\s'-]*$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  allPhoneNumber: /^(?:\+972-?|0)(?:5\d|[2-9]|7\d)(?:-)?\d{7}$/,
  IDCompanyId: /^(?:[0-9]{5,9}|51\d{7})$/,
  linkedin: /^https:\/\/www\.linkedin\.com\/in\//,
  groupName: /^([a-zA-Zא-ת\s'-]{3,})?$/,
}

export const invalid = {
  firstName: "רק אותיות בעברית או באנגלית בבקשה, עם 2 תווים לפחות",
  lastName: "ש להקליד אותיות בעברית או באנגלית בלבד וללא סימנים מיוחדים",
  phoneNumber: "אפשר להקליד כאן רק ספרות (עד 10 ספרות)",
  email: "כתובת המייל צריכה להיות במבנה הזה: name@email.com",
  allPhoneNumber: "מספר טלפון לא תקין",
  description: "כאן צריך לכתוב בקצרה מדוע החלטת לשלוח פנייה",
  ID: 'מספר ת"ז/ח"פ לא תקין',
  linkedin: "הקישור אינו תקינה",
  subject: "subject error",
  groupName: "רק אותיות בעברית או באנגלית בבקשה, עם 3 תווים לפחות",
  fullName: "רק אותיות בעברית או באנגלית בבקשה, עם 5 תווים לפחות",
}

export const schemaCommon = {
  firstName: yup
    .string()
    .required("נשמח לדעת איך קוראים לך")
    .min(2, "רק אותיות בעברית או באנגלית בבקשה, עם 2 תווים לפחות")
    .matches(regex.singleName, invalid.firstName)
    .max(25, invalid.firstName),
  lastName: yup
    .string()
    .matches(regex.singleName, invalid.lastName)
    .max(25, invalid.lastName)
    .required("צריך למלא גם שם משפחה"),
  fullName: yup
    .string()
    .matches(regex.singleName, invalid.fullName)
    .max(50, invalid.firstName)
    .required("נשמח לדעת איך קוראים לך")
    .min(5, invalid.fullName),
  ID: yup
    .string()
    .matches(regex.IDCompanyId, invalid.ID)
    .required('אנא הקלד ת"ז/ח"פ'),
  phoneNumber: yup
    .string()
    .required("באיזה מספר נוכל ליצור איתך קשר?")
    .matches(regex.phoneNumber, invalid.phoneNumber)
    .length(10, invalid.phoneNumber)
    .max(10, invalid.phoneNumber),
  city: yup.string().required("צריך לנסות להקליד את שם העיר שוב"),
  subscribeEmail: yup
    .string()
    .email(invalid.email)
    .required("לאיזה מייל לשלוח לך את ההנחות, המבצעים והעדכונים?")
    .max(132, invalid.email),
  email: yup
    .string()
    .email(invalid.email)
    .required("איך אפשר ליצור איתך קשר במייל?")
    .max(132, invalid.email),
  allPhoneNumber: yup
    .string()
    .matches(regex.allPhoneNumber, invalid.allPhoneNumber)
    .required("מה המספר שלך? צריך למלא, כדי שנחזור אליך")
    .max(13, invalid.allPhoneNumber),
  description: yup
    .string()
    .required(invalid.description)
    .max(500, invalid.description),
  comments: yup.string().nullable().notRequired(),
  subject: yup
    .string()
    .min(1, "נשמח לדעת מה נושא הפנייה")
    .required("נשמח לדעת מה נושא הפנייה"),
  hotel: yup
    .string()
    .min(1, "נשמח לדעת באיזה מלון מדובר")
    .required("נשמח לדעת באיזה מלון מדובר "),
  file: yup.string().required("required"),
  fileName: yup.string().required("required"),
  linkedin: yup.string().matches(regex.linkedin, invalid.linkedin),
  subscrube: yup.boolean().required(),
  jobId: yup.string().required(),
  subscribe: yup
    .boolean()
    .oneOf([true], "חשוב לסמן את התיבה כדי שנוכל לשלוח לך את כל הטוב הזה")
    .required(),
  groupName: yup
    .string()
    .notRequired()
    .matches(regex.groupName, invalid.groupName),
  pdfFile: yup
    .string()
    .required("לא לשכוח את קורות החיים - זה חשוב כדי שנכיר אותך טוב יותר"),
  messageRequired: yup
    .string()
    .required("חשוב להוסיף פרטים נוספים שיעזרו לנו להבין במה מדובר"),
}
export const schemaDonationRequest = {
  stringValue: yup.string().min(1).max(50).required("required"),
  booleanValue: yup.string().max(50).required("required"),
  numberValue: yup
    .string()
    .matches(/^[0-9]+$/)
    .required("required"),
}

const userRegex = {
  fullname: /^[a-zA-Zא-ת\s'-]*$/,
  // eslint-disable-next-line no-useless-escape
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  phoneNumber: /^(?:\+972-?|0)(?:5\d|[2-9]|7\d)(?:-)?\d{7}$/,
  ID: /^(?:[0-9]{5,9}|51\d{7})$/,
}

const userInvalid = {
  fullname: "רק אותיות בעברית או באנגלית, עם 5 תווים לפחות",
  email: "כתובת המייל צריכה להיות במבנה הזה: name@email.com",
  phoneNumber: "אפשר להקליד כאן רק ספרות (עד 10 ספרות)",
  description: "כאן צריך לכתוב בקצרה מדוע החלטת לשלוח פנייה",
  ID: "צריך להקליד כאן מספר עם 9 ספרות",
  linkedin: "הקישור אינו תקינה",
  subject: "subject error",
}

export const userSchema = {
  fullname: yup
    .string()
    .min(5, userInvalid.fullname)
    .required("שדה ריק: נשמח לדעת איך קוראים לך :)"),
  email: yup
    .string()
    .matches(userRegex.email, userInvalid.email)
    .required("איך אפשר ליצור איתך קשר במייל?"),
  phoneNumber: yup
    .string()
    .matches(userRegex.phoneNumber, userInvalid.phoneNumber)
    .length(10, userInvalid.phoneNumber)
    .max(10, userInvalid.phoneNumber)
    .required("באיזה מספר נוכל ליצור איתך קשר?"),
  ID: yup
    .string()
    .matches(userRegex.ID, userInvalid.ID)
    .min(9, userInvalid.ID)
    .max(9, userInvalid.ID)
    .required('אנא הקלד ת"ז/ח"פ'),
  birthDate: yup
    .date()
    .typeError("נשמח לדעת מתי נולדת כדי לשלוח לך ברכה ליום ההולדת")
    .test(
      "is-old-enough",
      "אפשר להצטרף למועדון רק מגיל 18. נשמח לצרף אותך בעתיד",
      function (value) {
        if (!value) return true
        const currentYear = new Date().getFullYear()
        const birthYear = value.getFullYear()
        return currentYear - birthYear >= 18
      },
    )
    .required("נשמח לדעת מתי נולדת כדי לשלוח לך ברכה ליום ההולדת"),
  specialDate: yup.date().optional(),
  subscribe: yup.boolean(),
  termsAccept: yup.boolean().oneOf([true]).required(),
}
